import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { askRoute as askBetFilterRoute } from '../../actions/betFilter';
import { useShallowEqualSelector } from '../../hooks';
import useCatalogParams from '../../hooks/useCatalogParams';
import useMergeProps from '../../hooks/useMergeProps';
import { type StateType } from '../../states';

import RoutesCatalog from './RoutesCatalog';
import selectRouteCatalogSelector from './RoutesCatalog.selector';

const RoutesCatalogContainer = () => {
  const history = useHistory();
  const params = useCatalogParams();
  const dispatch = useDispatch();

  const selectorProps = useMemo(() => ({ ...params, history }), [params, history]);
  const selectedProps = useShallowEqualSelector((state: StateType) => selectRouteCatalogSelector(state, selectorProps));
  const askRoute = useCallback(
    (route: { route: string; betFilterId?: number }) => {
      dispatch(askBetFilterRoute(route));
    },
    [dispatch],
  );

  const actionsProps = useMemo(
    () => ({
      askRoute,
    }),
    [askRoute],
  );

  const enhancedProps = useMergeProps({ selectedProps, actionsProps });

  // @ts-ignore
  return <RoutesCatalog {...enhancedProps} />;
};

export default RoutesCatalogContainer;
